import React, { useEffect, useState } from "react";
import "./TopicsList.scss";
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";
import { HolderOutlined, MoreOutlined } from "@ant-design/icons";
import { Button, Modal, Popover, Spin, Switch } from "antd";
import { deleteApi, getApi, postApi } from "../../../utils/apiServices";
import {
  DELETE_TOPIC,
  ENABLE_OR_DISABLE_TOPIC,
  GET_TOPICS_LIST,
  UPDATE_TOPIC_ORDER,
} from "../../../utils/apiPath";
import ToastHelper from "../../../services/ToastHelper";
import { spinContent } from "../../../services/customData";
import { useNavigate } from "react-router-dom";

const TopicsList = () => {
  const navigate = useNavigate();
  const [topics, setTopics] = useState(null);
  const [open, setOpen] = useState(false);
  const [open1, setOpen1] = useState(false);
  const [loading, setLoading] = useState(false);
  const [deleteItem, setDeleteItem] = useState(null);

  const onDragEnd = (result) => {
    if (!result.destination) return;

    const items = Array.from(topics);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);

    setTopics(items);

    const topicOrderSequence = {
      topicOrderSequence: items.map((item, index) => ({
        topicId: item.topicId,
        orderSequence: index + 1,
      })),
    };
    updateOrderSequence(topicOrderSequence);
  };

  const toggleTopic = (id) => {
    setTopics(
      topics?.map((topic) =>
        topic?.id === id ? { ...topic, enabled: !topic?.enabled } : topic
      )
    );
  };

  const handleOpen = (id, isOpen) => {
    if (isOpen) {
      setOpen(id);
    } else {
      setOpen(null);
    }
  };

  useEffect(() => {
    getTopicsList();
  }, []);

  const getTopicsList = async () => {
    setLoading(true);
    try {
      const res = await getApi(`${GET_TOPICS_LIST}`);

      if (res?.statusCode === 200) {
        setTopics(res?.data);
        // ToastHelper.success("success");
        return res?.data;
      } else {
        ToastHelper.error("Something went wrong. Please try again.");
      }
    } catch (err) {
      ToastHelper.error(
        "Failed to connect to the server. Please try again later."
      );
    } finally {
      setLoading(false);
    }
    return null;
  };

  const handleDeleteModal = (item) => {
    setDeleteItem(item);
    setOpen(null);
    setOpen1(true);
  };

  const handleClose = () => {
    setDeleteItem(null);
    setOpen1(false);
  };

  const handleDeleteTopic = async () => {
    try {
      const res = await deleteApi(`${DELETE_TOPIC}?topicId=${deleteItem}`);

      if (res?.statusCode === 200) {
        ToastHelper.success("Topic deleted successfully");
        handleClose();
        getTopicsList();
      } else {
        ToastHelper.error("Something went wrong. Please try again.");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleEdit = (id, topic) => {
    navigate(`/manage-topics/edit/${id}`, {
      state: {
        topicData: topic,
      },
    });
  };

  const updateOrderSequence = async (data) => {
    try {
      const payload = data;
      const res = await postApi(`${UPDATE_TOPIC_ORDER}`, payload);

      if (res?.statusCode === 200) {
        ToastHelper.success("Topic order updated successfully");
        getTopicsList();
      } else {
        ToastHelper.error("Something went wrong. Please try again.");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const topicEnableOrDisable = async (topic) => {
    try {
      const res = await getApi(
        `${ENABLE_OR_DISABLE_TOPIC}?topicId=${topic?.topicId}`
      );

      if (res?.statusCode === 200) {
        ToastHelper.success(
          `Topic ${topic?.isActive ? "disbaled" : "enabled"} successfully`
        );
        getTopicsList();
      } else {
        ToastHelper.error("Something went wrong. Please try again.");
      }
    } catch (err) {
      ToastHelper.error(
        "Failed to connect to the server. Please try again later."
      );
    } finally {
      setLoading(false);
    }
    return null;
  };

  const handleTopicItems = (topic) => {
    if (topic?.topicType === 1) {
      navigate(`/manage-topics/advertisement/${topic?.topicId}`, {
        state: { topicData: topic },
      });
    } else if (topic?.topicType === 3) {
      navigate(`/manage-topics/category/${topic?.topicId}`, {
        state: { topicData: topic },
      });
    } else {
      navigate(`/manage-topics/product/${topic?.topicId}`, {
        state: { topicData: topic },
      });
    }
  };

  return (
    <div className="topics-list">
      <div className="topics-list_container">
        <div className="topics-list_cards">
          <DragDropContext onDragEnd={onDragEnd}>
            <Droppable droppableId="topics">
              {(provided) => (
                <div
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                  className="topics-list_cards_list"
                >
                  {loading ? (
                    <Spin tip="Loading">{spinContent}</Spin>
                  ) : topics?.length > 0 ? (
                    topics?.map((topic, index) => (
                      <Draggable
                        key={String(topic?.topicId)}
                        draggableId={String(topic?.topicId)}
                        index={index}
                      >
                        {(provided) => (
                          <div
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            className={`topics-list_card ${
                              !topic?.isActive ? "disable" : ""
                            }`}
                            onClick={() => handleTopicItems(topic)}
                          >
                            <div className="topics-list_card_left">
                              <div
                                onClick={(e) => e.stopPropagation()}
                                className="topics-list_card_left_icon"
                                {...provided.dragHandleProps}
                              >
                                <HolderOutlined style={{ fontSize: "18px" }} />
                              </div>
                              <div className="topics-list_card_left_content">
                                <div className="topics-list_card_left_content_top">
                                  <h3>{topic?.title}</h3>
                                  <span>{topic?.topicTypeName}</span>
                                </div>
                                {topic?.topicType === 1 && topic?.desktopTileCount !== 0 && (
                                  <p>Desktop Tile Count: {topic?.desktopTileCount}</p>
                                )}
                                {topic?.topicType === 1 && topic?.mobileTileCount !== 0 && (
                                  <p>Mobile Tile Count: {topic?.mobileTileCount}</p>
                                )}
                              </div>
                            </div>
                            <div className="topics-list_card_right">
                              <div
                                className="topics-list_card_right_sec"
                                onClick={(e) => e.stopPropagation()}
                              >
                                <Popover
                                  overlayClassName="plugin-screenshot-popover"
                                  content={
                                    <div className="topics-list_card_right_sec_options">
                                      <Button
                                        type="primary"
                                        onClick={() =>
                                          handleEdit(topic?.topicId, topic)
                                        }
                                      >
                                        Edit
                                      </Button>
                                      <Button
                                        onClick={() =>
                                          handleDeleteModal(topic?.topicId)
                                        }
                                      >
                                        Delete
                                      </Button>
                                    </div>
                                  }
                                  arrow={true}
                                  trigger="click"
                                  placement="topRight"
                                  open={open === topic?.topicId}
                                  onOpenChange={(isOpen) =>
                                    handleOpen(topic?.topicId, isOpen)
                                  }
                                >
                                  <MoreOutlined style={{ fontSize: "18px" }} />
                                </Popover>
                              </div>
                              <div
                                className="topics-list_card_right_sec"
                                onClick={(e) => e.stopPropagation()}
                              >
                                <Switch
                                  size="small"
                                  checked={topic?.isActive}
                                  onChange={() => {
                                    toggleTopic(topic?.topicId);
                                    topicEnableOrDisable(topic);
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        )}
                      </Draggable>
                    ))
                  ) : (
                    <h5>No topic available</h5>
                  )}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
        </div>
      </div>
      <Modal
        title="Confirm"
        open={open1}
        onOk={handleDeleteTopic}
        onCancel={handleClose}
        width={300}
      >
        <p>Are you sure want to delete?</p>
      </Modal>
    </div>
  );
};

export default TopicsList;
